<template>
  <div id="clinical-test" class="clinical-container">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div v-if="clinicalTestData" class="clinical-text-container">
            <h2>{{ clinicalTestData.lefttitle }}</h2>
            <h3>{{ clinicalTestData.leftdescription }}</h3>
            <div class="inner-container">
              <div class="row">
                <div class="col-sm-6">
                  <span>{{ clinicalTestData.leftpercentage1 }}%</span>
                  <p>{{ clinicalTestData.leftdescription1 }}</p>
                </div>
                <div class="col-sm-6">
                  <span>{{ clinicalTestData.leftpercentage2 }}%</span>
                  <p>{{ clinicalTestData.leftdescription2 }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <span>{{ clinicalTestData.leftpercentage3 }}%</span>
                  <p>{{ clinicalTestData.leftdescription3 }}</p>
                </div>
                <div class="col-sm-6">
                  <span>{{ clinicalTestData.leftpercentage4 }}%</span>
                  <p>{{ clinicalTestData.leftdescription4 }}</p>
                </div>
              </div>
            </div>
            <div class="desp">{{ clinicalTestData.leftterms }}</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="clinical-image-container moveright">
            <img :src="clinicalTestData.rightimage" alt="" />
          </div>
        </div>
      </div>
      <div v-if="clinicalTestData.clinicaltypetwo" class="row topmargin mobile-change-order">
        <div class="col-md-6 mobile-show-second">
          <div class="clinical-image-container moveleft">
            <img class="" :src="clinicalTestData.leftimage" alt="" />
          </div>
        </div>
        <div class="col-md-6 mobile-show-first">
          <div class="clinical-text-container">
            <h2>{{ clinicalTestData.righttitle }}</h2>
            <h3>{{ clinicalTestData.rightdescription }}</h3>
            <div class="inner-container">
              <div class="row">
                <div class="col-sm-6">
                  <span>{{ clinicalTestData.rightpercentage1 }}%</span>
                  <p>{{ clinicalTestData.rightdescription1 }}</p>
                </div>
                <div class="col-sm-6">
                  <span>{{ clinicalTestData.rightpercentage2 }}%</span>
                  <p>{{ clinicalTestData.rightdescription2 }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <span>{{ clinicalTestData.rightpercentage3 }}%</span>
                  <p>{{ clinicalTestData.rightdescription3 }}</p>
                </div>
                <div class="col-sm-6">
                  <span>{{ clinicalTestData.rightpercentage4 }}%</span>
                  <p>{{ clinicalTestData.rightdescription4 }}</p>
                </div>
              </div>
            </div>
            <div class="desp">{{ clinicalTestData.rightterms }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mixa-clinical-test',
  props: {
    clinicalTestData: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    let clinicalData = document.querySelectorAll('.clinical-container p');
    for (let i = 0; i < clinicalData.length; i++) {
      if (clinicalData[i].offsetHeight > 100) {
        clinicalData[i].style.height = '110px';
      }
    }
  },
};
</script>
